<template lang="pug">
  el-tabs.tabs(
    @tab-click="handleClick",
    v-model="abaAtiva",
  )
    el-tab-pane(name='geral')
      span(slot="label" id="GERAL")
          | Geral &nbsp
      div
        informacoes-cadastro(:cadastroGleba="gleba")
    el-tab-pane(name='cadastrante')
      span(slot="label" id="CADASTRANTE")
          | Cadastrante &nbsp
      div
        informacoes-cadastrante(:cadastroGleba="gleba")
    el-tab-pane(name='georreferenciamento')
      span(slot="label" id="GEORREFERENCIAMENTO")
          | Georreferenciamento &nbsp
      div
        informacoes-geo(:cadastroGleba="gleba" :isVisivel="abaAtiva === 'georreferenciamento'")
</template>

<script>
import { mapActions } from 'vuex'
import InformacoesCadastro from '../components/InformacoesCadastro.vue'
import InformacoesCadastrante from '../components/InformacoesCadastrante.vue'
import InformacoesGeo from '../components/InformacoesGeo.vue'

export default {

  components: {
    InformacoesCadastro,
    InformacoesCadastrante,
    InformacoesGeo
  },

  props: {
    idGleba: {
      required: true
    }
  },

  data () {
    return {
      abaAtiva: 'geral',
      gleba: {}
    }
  },
  mounted () {
  },

  async created () {
    this.gleba = await this.buscarGleba(this.idGleba)
  },

  computed: {
  },

  methods: {
    ...mapActions({
      buscarGleba: 'gleba/buscarGleba'
    }),
    async handleClick (tab) {
      this.abaAtiva = tab.name
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

  .label {
    font-size: 16px;
  }

  body {
    word-break: break-word !important;
  }

  /deep/ .el-collapse-item__header {
    font-size: 16px;
    color: $font-dark-color;
    font-weight: bold;
  }

  /deep/ .el-collapse-item__content {
    font-size: unset !important;
    color: unset !important;
  }

</style>



// WEBPACK FOOTER //
// src/screens/bancoDados/gleba/TabsVisualizarGleba.vue